import { ChangeDetectionStrategy, Component, input } from '@angular/core';

export interface ChartLegendItem {
  label: string;
  color: string;
}

@Component({
    selector: 'chart-legend',
    templateUrl: './chart-legend.component.html',
    styleUrl: './chart-legend.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChartLegendComponent {
  items = input<ChartLegendItem[]>([]);
  selectedIndex = input<number | null>(null);
}
